module.exports = __webpack_public_path__ + "img/hotel1.00a0d177.png";